
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  A gallery is a collection of images or videos that allows a user to quickly
  browse media related to the page content. The media gallery can include
  multiple types of formats and sometimes act as links to other pages or sites.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Galleries/Gallery.jpg" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/Galleries/Gallery%20-%20Mobile.jpg 598w, https://inno-ecl.s3.amazonaws.com/media/images/EC/Galleries/Gallery.jpg 1246w" alt="Anatomy of navigation lists" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Media`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Title must describe the downloadable file`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Media icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Icon indicating the type of media`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Caption`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use caption `}<strong>{`representative`}</strong>{` of the media content - this allows users to form a mental model of the information available while scanning the page`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`be descriptive and concise in the caption`}</strong>{` to communicate the subject of the media file`}</li>
      <li parentName="ul"><strong parentName="li">{`write captions that are short, distinct and indicative`}</strong>{` and communicate the subject of the media content`}</li>
      <li parentName="ul"><strong parentName="li">{`include ALT tag`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`select appropriate images`}</strong>{` for video thumbnails, they need to depict what is in the audio or video file`}</li>
      <li parentName="ul">{`place icon overlays to indicate the type of media, i.e. audio icon, video icon.`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't automatically play audio or video files`}</strong>{` when a user arrives on a page (or scrolls to a media gallery)`}</li>
      <li parentName="ul"><strong parentName="li">{`don't automatically play next items`}</strong>{` after an audio or video item finished`}</li>
      <li parentName="ul">{`don't choose images which are too complex to be distinguished in thumbnail size`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`where there are several media files - if there are under 5 items, use use an `}<Link to="/ec/components/list/usage/" mdxType="Link">{`unordered list`}</Link>{` or a `}<Link to="/ec/components/media/media-container/usage/" mdxType="Link">{`media container`}</Link></li>
      <li parentName="ul">{`where there is no need to prioritise or highlight specific media files, i.e. files are equally important in terms of content`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not use the gallery when media items have a content hierarchy`}</li>
      <li parentName="ul">{`do not use the gallery when specific items should be highlighted`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Accessibility`}</h3>
    <ul>
      <li parentName="ul">{`Ensure the `}<strong parentName="li">{`ALT tag for each media file accurately describes the subject`}</strong>{` (e.g. for an image: "Undergraduate student looking into microscope to examine specimen in biology laboratory" instead of something generic like "Science image 1")`}</li>
    </ul>
    <h3>{`Design`}</h3>
    <ul>
      <li parentName="ul">{`Captions`}<ul parentName="li">
          <li parentName="ul">{`Desktop: display on hover`}</li>
          <li parentName="ul">{`Mobile: display under the thumbnail`}</li>
        </ul></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;